import React from 'react'
import { useTranslation } from 'react-i18next'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import SelectionCard from '../../../../../../components/WizardModal/SelectionCard'

const ElectricalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M4.26584 14.9297C4.06404 14.9303 3.86619 14.8738 3.69527 14.7665C3.52435 14.6592 3.38737 14.5056 3.30027 14.3236C3.21316 14.1415 3.17949 13.9385 3.20317 13.7381C3.22685 13.5377 3.30691 13.3481 3.43405 13.1914L13.9915 2.31407C14.0707 2.22266 14.1786 2.16089 14.2975 2.1389C14.4164 2.1169 14.5393 2.13599 14.646 2.19304C14.7526 2.25008 14.8367 2.34169 14.8844 2.45282C14.9321 2.56395 14.9407 2.688 14.9086 2.80462L12.8611 9.22438C12.8007 9.38597 12.7804 9.55979 12.802 9.73093C12.8236 9.90208 12.8863 10.0654 12.9849 10.207C13.0834 10.3486 13.2149 10.4641 13.3679 10.5437C13.5209 10.6233 13.691 10.6646 13.8635 10.664H21.3283C21.5301 10.6633 21.728 10.7199 21.8989 10.8272C22.0698 10.9345 22.2068 11.0881 22.2939 11.2701C22.381 11.4522 22.4147 11.6552 22.391 11.8556C22.3673 12.056 22.2873 12.2456 22.1601 12.4023L11.6027 23.2796C11.5235 23.371 11.4156 23.4328 11.2967 23.4548C11.1778 23.4768 11.0549 23.4577 10.9482 23.4007C10.8416 23.3436 10.7575 23.252 10.7098 23.1409C10.6621 23.0297 10.6535 22.9057 10.6856 22.7891L12.7331 16.3693C12.7935 16.2077 12.8138 16.0339 12.7922 15.8628C12.7706 15.6916 12.7079 15.5283 12.6093 15.3867C12.5107 15.2451 12.3793 15.1296 12.2263 15.05C12.0732 14.9704 11.9032 14.9291 11.7307 14.9297H4.26584Z" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const OtherIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M12.7969 13.8633C13.3858 13.8633 13.8633 13.3858 13.8633 12.7969C13.8633 12.2079 13.3858 11.7305 12.7969 11.7305C12.2079 11.7305 11.7305 12.2079 11.7305 12.7969C11.7305 13.3858 12.2079 13.8633 12.7969 13.8633Z" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.2617 13.8633C20.8507 13.8633 21.3281 13.3858 21.3281 12.7969C21.3281 12.2079 20.8507 11.7305 20.2617 11.7305C19.6728 11.7305 19.1953 12.2079 19.1953 12.7969C19.1953 13.3858 19.6728 13.8633 20.2617 13.8633Z" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.33203 13.8633C5.92099 13.8633 6.39844 13.3858 6.39844 12.7969C6.39844 12.2079 5.92099 11.7305 5.33203 11.7305C4.74307 11.7305 4.26562 12.2079 4.26562 12.7969C4.26562 13.3858 4.74307 13.8633 5.33203 13.8633Z" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const ApplianceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M5.33203 6.39844C5.33203 5.26712 5.78144 4.18215 6.5814 3.38219C7.38136 2.58223 8.46634 2.13281 9.59766 2.13281H15.9961C17.1274 2.13281 18.2124 2.58223 19.0123 3.38219C19.8123 4.18215 20.2617 5.26712 20.2617 6.39844V21.3281C20.2617 21.8938 20.037 22.4363 19.637 22.8363C19.2371 23.2362 18.6946 23.4609 18.1289 23.4609H7.46484C6.89919 23.4609 6.3567 23.2362 5.95672 22.8363C5.55674 22.4363 5.33203 21.8938 5.33203 21.3281V6.39844Z" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.33203 10.6641H20.2617" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.9961 7.46484V13.8633" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const HeatingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M9.06445 15.4629C9.77152 15.4629 10.4496 15.182 10.9496 14.682C11.4496 14.1821 11.7305 13.5039 11.7305 12.7969C11.7305 11.3252 11.1973 10.6641 10.6641 9.59766C9.52087 7.31235 10.4252 5.27445 12.7969 3.19922C13.3301 5.86523 14.9297 8.42461 17.0625 10.1309C19.1953 11.8371 20.2617 13.8633 20.2617 15.9961C20.2617 16.9764 20.0686 17.9471 19.6935 18.8528C19.3183 19.7584 18.7685 20.5814 18.0753 21.2745C17.3821 21.9677 16.5592 22.5176 15.6535 22.8927C14.7479 23.2679 13.7772 23.4609 12.7969 23.4609C11.8166 23.4609 10.8459 23.2679 9.9402 22.8927C9.03453 22.5176 8.21161 21.9677 7.51843 21.2745C6.82526 20.5814 6.2754 19.7584 5.90026 18.8528C5.52511 17.9471 5.33203 16.9764 5.33203 15.9961C5.33203 14.7665 5.79379 13.5498 6.39844 12.7969C6.39844 13.5039 6.67932 14.1821 7.1793 14.682C7.67927 15.182 8.35738 15.4629 9.06445 15.4629Z" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const PlumbingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path d="M7.46484 17.3824C9.81094 17.3824 11.7305 15.4309 11.7305 13.0635C11.7305 11.8265 11.1226 10.6534 9.90691 9.66167C8.69121 8.66991 7.7741 7.19827 7.46484 5.65198C7.15559 7.19827 6.24914 8.68057 5.02277 9.66167C3.79641 10.6428 3.19922 11.8371 3.19922 13.0635C3.19922 15.4309 5.11875 17.3824 7.46484 17.3824Z" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3943 7.03832C14.1277 5.86647 14.6476 4.5739 14.9299 3.22058C15.4631 5.8866 17.0627 8.44597 19.1955 10.1522C21.3283 11.8585 22.3947 13.8846 22.3947 16.0175C22.4008 17.4915 21.9691 18.9342 21.1543 20.1627C20.3395 21.3911 19.1783 22.3499 17.8179 22.9176C16.4575 23.4853 14.9591 23.6363 13.5128 23.3514C12.0665 23.0666 10.7374 22.3587 9.69385 21.3175" stroke="currentColor" strokeWidth="2.13281" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

interface IssueTypeStepProps {
  value: string
  onChange: (value: string) => void
  onEmergencySelect?: () => void
}

const ISSUE_TYPES = [
  {
    key: 'plumbing',
    icon: <PlumbingIcon />,
    title: 'Plumbing',
    description: 'Leaks, pipes, drains, water damage',
  },
  {
    key: 'electrical',
    icon: <ElectricalIcon />,
    title: 'Electrical',
    description: 'Outlets, lighting, circuit breakers',
  },
  {
    key: 'heating',
    icon: <HeatingIcon />,
    title: 'Heating & Cooling',
    description: 'HVAC, radiators, ventilation',
  },
  {
    key: 'appliance',
    icon: <ApplianceIcon />,
    title: 'Appliance',
    description: 'Built-in appliances or fixtures',
  },
  {
    key: 'other',
    icon: <OtherIcon />,
    title: 'Other',
    description: 'Something else not listed above',
  },
]

const IssueTypeStep = ({ value, onChange, onEmergencySelect }: IssueTypeStepProps) => {
  const { t } = useTranslation()

  return (
    <div>
      <h3 className="text-base font-semibold text-[#0a0d47] mb-3">
        {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.EMERGENCY_SAFETY_SECTION')}
      </h3>
      <button
        type="button"
        onClick={onEmergencySelect}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          width: '100%',
          padding: '18px 24px',
          marginBottom: 28,
          borderRadius: 12,
          border: '2px solid #E53935',
          background: '#FFEBEE',
          cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <ExclamationTriangleIcon style={{ width: 28, height: 28, color: '#E53935', flexShrink: 0 }} />
        <div>
          <p style={{ margin: '0 0 2px', fontSize: '0.875rem', fontWeight: 600, color: '#C62828' }}>
            {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_LEAK_TITLE')}
          </p>
          <p style={{ margin: 0, fontSize: '0.8125rem', color: '#E57373' }}>
            {t('REPAIR_AND_INQUIRIES.NEW_DAMAGE_REPORT.GAS_LEAK_DESCRIPTION')}
          </p>
        </div>
      </button>

      <h3 className="text-base font-semibold text-[#0a0d47] mb-1">What needs fixing?</h3>
      <p className="text-sm text-gray-500 mb-5">Select the category that best describes the issue.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {ISSUE_TYPES.map((issue) => (
          <SelectionCard
            key={issue.key}
            icon={issue.icon}
            title={issue.title}
            description={issue.description}
            selected={value === issue.key}
            onClick={() => onChange(issue.key)}
          />
        ))}
      </div>
    </div>
  )
}

export default IssueTypeStep
